module.exports = {
  Webpage: {
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    opacity: "Opaklık",
    padding: "Alan",

    PluginName: "Web Sayfası",
    radius: "Radyan",
    source: "Kaynak",
    URL: "URL",
    URL_copypaste: "URL Kopyala & yapıştır",
    fixedPosition: "Kaydırma çubuğunu kaldır",
  },
};
